export default {
  metadata: {
    version: '1.0.0',
    id: 'side-panel-1.0.0',
    name: 'JDSSidePanel',
    description: ''
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_side_panel_internal']
      }
    ]
  },
  base: {
    popup: {
      priority: 40,
      passive: true,
      show: true
    },
    'popup-container': {
      'background-color': '#141414D9',
      height: '{s_0}',
      width: '{s_1}',
      'flex-direction': '{s_2}',
      'justify-content': '{s_3}',
      'align-items': '{s_4}',
      'enter-animation-name': 'fadeIn',
      'exit-animation-name': 'fadeOut',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      opacity: '{opacity.invisible}',
      transition: {
        property: ['opacity'],
        duration: '{medium}',
        'timing-function': '{easeRapid}'
      }
    },
    jds_side_panel_internal: {
      open: false,
      maxWidth: false
    }
  },
  variant: {
    open: {
      true: {
        popup: {
          passive: false
        },
        'popup-container': {
          opacity: '{opacity.enabled}'
        },
        jds_side_panel_internal: {
          open: true
        }
      }
    },
    direction: {
      right: {
        'popup-container': {
          'justify-content': '{s_27}'
        },
        jds_side_panel_internal: {
          direction: 'right'
        }
      }
    },
    maxWidth: {
      true: {
        jds_side_panel_internal: {
          maxWidth: true
        }
      }
    },
    showClose: {
      false: {
        jds_side_panel_internal: {
          showClose: false
        }
      }
    }
  },
  combination: [{}],
  combination_config: [],
  api: {
    config: {
      direction: {
        values: ['left', 'right'],
        doc_description:
          'Determines whether open/close should happen from left or right.'
      },
      showClose: {
        values: [true, false],
        doc_description: 'Whether a close on the right should be shown.'
      },
      open: {
        values: [false, true],
        doc_description:
          'Can be used to programatically open/close the drawer with animation and selected direction.'
      },
      maxWidth: {
        values: [false, true],
        doc_description:
          'If set it will limit max width of the panel to 412px.',
        function: true
      },
      disableTransition: {
        values: [false, true],
        platform: 'web'
      }
    },
    data: {
      jds_side_panel_internal: {
        items: {
          type: 'list',
          name: 'items',
          object: {
            title: 'string',
            prefix: 'icon',
            showSuffix: 'boolean',
            type: 'JDSSidePanelItem.type'
          }
        },
        'items.prefix': {
          type: 'string',
          name: 'items.prefix'
        },
        'items.title': {
          type: 'string',
          name: 'items.title'
        },
        'links.showSuffix': {
          type: 'boolean',
          name: 'links.showSuffix'
        },
        'items.type': {
          type: 'string',
          name: 'items.type'
        },
        prefix: {
          name: 'prefix',
          type: 'slot',
          accepts: ['jds_avatar', 'jds_icon', 'jds_button'],
          max: 1
        },
        header: {
          name: 'header',
          type: 'slot',
          doc_description: 'Has pre-defined suffix as close button.',
          accepts: ['jds_text'],
          max: 1
        },
        children: {
          name: 'children',
          type: 'slot',
          doc_description:
            'Any group of children can be added. When used for BurgerMenu, show a list of ListBlocks.',
          accepts: ['any']
        }
      }
    },
    events: {
      jds_side_panel_internal: {
        onClose: 'onClose',
        onContainerClick: '_onContainerClick',
        onSwipeLeft: 'onClose',
        onSidePanelSuffixClick: 'onSidePanelSuffixClick'
      },
      popup: {
        onClick: 'onClose'
      }
    },
    a11y: {
      jds_side_panel_internal: {
        name: 'items',
        repeating: {
          itemAriaLabel: 'itemAriaLabel',
          itemSuffixAriaLabel: 'itemSuffixAriaLabel',
          itemAriaDescribedby: {
            name: 'itemAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
